import labels from "../constants/displayFields";

export const FIELD_ORDER_SECTIONS = [
  {
    id: "identifiers",
    title: "Identifiers",
  },
  {
    id: "descriptive",
    title: "Descriptive",
  },
  {
    id: "origin",
    title: "Origin",
  },
  {
    id: "destination",
    title: "Destination",
  },
  {
    id: "configurable",
    title: "Configurable Fields",
  },
  {
    id: "storage",
    title: "Storage",
  },
  {
    id: "electrical",
    title: "Electrical",
  },
  {
    id: "plumbing",
    title: "Plumbing",
  },
  {
    id: "mechanical",
    title: "Mechanical",
  },
];

export const getFieldLabel = (field) => {
  if (field.id.startsWith("customField") && field.params?.field) {
    return field.params.field.defaultLabel;
  } else if (field.params?.label) {
    return field.params.label;
  } else if (labels[field.id]) {
    return labels[field.id];
  }
  return field.label || field.id;
};

export const reorderFields = (orderedFields, result) => {
  if (!result.destination) {
    return orderedFields;
  }

  const { source, destination } = result;

  // If dropped in the same position, do nothing
  if (source.droppableId === destination.droppableId && source.index === destination.index) {
    return orderedFields;
  }

  if (source.droppableId === destination.droppableId) {
    const sectionId = source.droppableId;
    const items = Array.from(orderedFields[sectionId] || []);
    const [reorderedItem] = items.splice(source.index, 1);
    items.splice(destination.index, 0, reorderedItem);

    return {
      ...orderedFields,
      [sectionId]: items,
    };
  } else {
    const sourceSectionId = source.droppableId;
    const destSectionId = destination.droppableId;
    const sourceItems = Array.from(orderedFields[sourceSectionId] || []);
    const destItems = Array.from(orderedFields[destSectionId] || []);
    const [movedItem] = sourceItems.splice(source.index, 1);

    const updatedItem = {
      ...movedItem,
      section: destSectionId,
    };

    destItems.splice(destination.index, 0, updatedItem);

    return {
      ...orderedFields,
      [sourceSectionId]: sourceItems,
      [destSectionId]: destItems,
    };
  }
};
